import React, { useRef, useState, useEffect } from 'react';
import { Input } from 'antd';
import { api, apiHolder, apis } from 'api';
import styles from './mail.module.scss';
import SiriusRadio from '@web-common/components/UI/SiriusRadio';
import ErrorIcon from '@web-common/components/UI/Icons/svgs/ErrorSvg';
import Modal from '@web-common/components/UI/Modal/SiriusModal';
import useRisk from '@web-common/hooks/useRisk';
import { emailPattern, ProductProtocols } from '@web-common/utils/constant';
import { getIn18Text } from 'api';
const loginApi = api.requireLogicalApi(apis.loginApiImpl);
const trackApi = apiHolder.api.requireLogicalApi(apis.dataTrackerApiImp);
const mailPattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const MailValidateForm = props => {
    const { defaultAccount = '', defaultPwd = '', showProtocol = true, onSubmit, submitTxt } = props;
    const inputRef = useRef(null);
    const [account, setAccount] = useState(defaultAccount);
    const [pwd, setPwd] = useState(defaultPwd);
    const [errorTxt, setErrorTxt] = useState('');
    const [protocolChecked, setProtocolChecked] = useState(false);
    const [loading, setLoading] = useState(false);
    const submit = async () => {
        if (loading) {
            return;
        }
        if (!account) {
            setErrorTxt(getIn18Text('QINGSHURUYOUXIANGZHANG'));
            return;
        }
        if (!pwd) {
            setErrorTxt(getIn18Text('QINGSHURUMIMA'));
            return;
        }
        if (!mailPattern.test(account)) {
            setErrorTxt(getIn18Text('YOUXIANGZHANGHAOGE'));
            return;
        }
        if (!protocolChecked) {
            const t = (React.createElement("span", { className: styles.uProtocol, onClick: e => e.stopPropagation() },
                React.createElement("span", null, getIn18Text('QINGXIANTONGYI')),
                React.createElement("a", { href: ProductProtocols.agreement, target: "_blank", rel: "noreferrer" }, getIn18Text('FUWUTIAOKUAN')),
                React.createElement("span", null, getIn18Text('HE')),
                React.createElement("a", { href: ProductProtocols.privacy, target: "_blank", rel: "noreferrer" }, getIn18Text('YINSIZHENGCE'))));
            Modal.error({
                title: t,
                okText: getIn18Text('ZHIDAOLE'),
                centered: true,
                hideCancel: true,
            });
            return;
        }
        setLoading(true);
        const res = await loginApi.doPreLogin(account);
        if (typeof res === 'object' && res.errmsg) {
            setErrorTxt(res.errmsg);
            return;
        }
        if (typeof res === 'string') {
            setErrorTxt(res);
            return;
        }
        const errMsg = await onSubmit(account, pwd);
        setLoading(false);
        setErrorTxt(errMsg);
    };
    const onPreLogin = () => {
        if (account) {
            const pattern = emailPattern;
            if (pattern.test(account)) {
                loginApi.doPreLogin(account);
            }
            else {
                setErrorTxt(getIn18Text('YOUXIANGZHANGHAOGE'));
            }
        }
    };
    useEffect(() => {
        var _a;
        (_a = inputRef === null || inputRef === void 0 ? void 0 : inputRef.current) === null || _a === void 0 ? void 0 : _a.focus({
            cursor: 'end',
        });
    }, []);
    useEffect(() => {
        setAccount(defaultAccount);
    }, [defaultAccount]);
    return (React.createElement("div", { className: styles.wrap },
        React.createElement("div", { className: styles.accountWrap },
            React.createElement(Input, { allowClear: true, placeholder: getIn18Text('WANGYIQIYEYOU'), value: account, ref: inputRef, readOnly: !!defaultAccount, onChange: e => {
                    setAccount(e.target.value);
                }, onFocus: () => {
                    onPreLogin();
                    setErrorTxt('');
                }, autoComplete: "off", suffix: null })),
        React.createElement("div", { className: styles.pwdWrap },
            React.createElement(Input.Password, { allowClear: true, placeholder: getIn18Text('QINGSHURUMIMA'), value: pwd, onFocus: () => {
                    setErrorTxt('');
                }, onChange: e => {
                    setPwd(e.target.value);
                } })),
        React.createElement("div", { hidden: !showProtocol, className: styles.protocolWrap, onClick: e => {
                setProtocolChecked(checked => !checked);
                e.stopPropagation();
            } },
            React.createElement(SiriusRadio, { checked: protocolChecked },
                React.createElement("span", { className: styles.uProtocol, onClick: e => e.stopPropagation() },
                    React.createElement("span", null, getIn18Text('WOYIYUEDUBING')),
                    React.createElement("a", { href: ProductProtocols.agreement, target: "_blank", rel: "noreferrer" }, getIn18Text('FUWUTIAOKUAN')),
                    React.createElement("span", null, getIn18Text('HE')),
                    React.createElement("a", { href: ProductProtocols.privacy, target: "_blank", rel: "noreferrer" }, getIn18Text('YINSIZHENGCE'))))),
        React.createElement("div", { className: styles.submitBtn, onClick: submit }, submitTxt + (loading ? getIn18Text('ZHONG...') : '')),
        React.createElement("div", { className: styles.errorWrap, hidden: !errorTxt },
            React.createElement(ErrorIcon, { width: 14, height: 14, className: styles.errorIcon }),
            React.createElement("span", { className: styles.errorText }, errorTxt))));
};
const MailValidate = props => {
    const { from, onSuccess, defaultAccount, currentAccountNode } = props;
    const { riskManage } = useRisk();
    const submitTxtMap = {
        login: getIn18Text('DENGLU'),
        account: getIn18Text('DENGLU'),
    };
    useEffect(() => {
        trackApi.track('pc_verify_email_account_page', { pageSource: from });
    }, []);
    const onSubmit = async (account, pwd) => {
        const loginRes = await loginApi.doMobileValidateAccountLogin({
            account,
            password: pwd,
            currentAccountNode,
        });
        const { pass, errmsg, riskVerify, showMailMasterDownload } = loginRes;
        if (pass) {
            onSuccess && onSuccess();
            trackApi.track('pc_verify_email_account_page_result', { pageSource: from, actionresult: true });
        }
        else if (riskVerify) {
            riskManage({ val: loginRes, callback: () => onSuccess && onSuccess() });
            return errmsg;
        }
        else if (showMailMasterDownload) {
            Modal.error({
                content: getIn18Text('UPDATE_TO_MM'),
                maskClosable: false,
                okText: getIn18Text('DOWNLOAD_NOW'),
                onOk: () => {
                    loginApi.doOpenMailMasterDownloadPage();
                },
            });
        }
        trackApi.track('pc_verify_email_account_page_result', { pageSource: from, actionresult: errmsg });
        return errmsg;
    };
    const submitTxt = submitTxtMap[from];
    return React.createElement(MailValidateForm, { defaultAccount: defaultAccount, onSubmit: onSubmit, submitTxt: submitTxt });
};
export default MailValidate;
